<template>
<div>
  <tl-header type="h1">
    <div>Departments</div>

    <template slot="icon">
      <div class="row-container" v-show="ifTeamleaderPermission">
        <button class="addnewbtn" v-if="departmentsListData[le_id] && departmentsListData[le_id].length>3" @click="createForm()">
            <img src="@/assets/group-5.svg" />
            <b>Add New</b>
        </button>
        <!-- <img src="@/assets/logout-copy-2.svg" class="logout-copy-2" />
        <button class="export-button">Upload</button>
        <div class="showIntro" @click="goToIntro"><img src="@/assets/questionmark.png"></div> -->
      </div>
    </template>
  </tl-header>

    <div class="permission-alert-msg" v-show="!(ifTeamleaderPermission)">
      You have only view permission.
    </div>

  <div v-if="!(departmentsListData[le_id] ? departmentsListData[le_id].length : 0)">
    <div class="noData">
      <span>
        You have not added any Department yet.
      </span>
    </div>
    <form-add-button main_text="+ Add New " v-show="showButton"
    sub_text="Department" @click="createForm()"
    v-if="ifTeamleaderPermission">
    </form-add-button>
  </div>
  <div v-else>
    <div :disabled="!(ifTeamleaderPermission)">
      <data-table :columns="departmentColumnNames" :tableData="departmentsListData[le_id]"
      :checkbox="false"
       :withForm="false"
       :showhistory="false"
        @editStart="initEditStart"
        @delete="deleteItem"
        @update="updateItem"/>
    </div>
    <form-add-button v-if="adddialog" main_text="+ Add New"
    sub_text="Department" @click="createForm()"
     v-show="ifTeamleaderPermission">
    </form-add-button>
     <toast-message :message="errmsg" v-show="toast" type="error" />
  </div>

  <pop-up-message
    v-if="showPopup"
    :message="popupMessage"
    :popupType="popupType"
    :popupHeaderMessage="'Confirm Delete'"
    :closable="false"
  >
    <template v-slot:bottomContent>
      <btn-grp>
        <popup-btn text="Cancel" type="secondary" @click="cancelEvent" />
        <popup-btn text="Delete" type="primary" @click="deleteEvent" />
      </btn-grp>
    </template>
  </pop-up-message>

  <bottom-action-container>
      <btn-skip @navClicked="continuee"></btn-skip>
      <template slot="end">
        <btn-grp>
          <btn text="Previous" type="secondary" @click="previous"/>
          <btn text="Next" type="primary" @click="continuee"/>
        </btn-grp>
      </template>
    </bottom-action-container>
</div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "DepartmentsList",
  computed: {
    ...mapState("onboard/departments", {
      departmentsListData: state => state.data,
      isFetching: state => state.isFetching,
      isSaving: state => state.isSaving,
      isDeleting: state => state.isDeleting
    }),
    orgId() {
      return this.$store.getters["onboard/getOrgId"];
    },
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    adddialog() {
      return !this.showForm;
    },
    isLoading() {
      return this.isFetching;
    },
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },
    ...mapState("onboard/organization", {
      orgIds: state => state.id,
    }),
    ifTeamleaderPermission() {
      if(this.role === 'ADMIN') {
        return true;
      } else if(this.role === 'TEAMLEADER') {
        if(this.departmentsValue) {
          return true;
        } 
        else {
          return false;
        }
      } else {
        return false
      }

      // if(this.role === 'TEAMLEADER' || this.role === 'ADMIN') {
      //   if(this.departmentsValue) {
      //   return true;
      //   } else {
      //     return false;
      //   }
      // }
      // else {
      //  return true
      // }
    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },
  },
  data() {
    return {
      mode: "add",
      showButton: true,
      showForm: false,
      showEnableBtn: false,
      editModel: "in-page",
      isFormActive: false,
      list: [],
      errmsg: "",
      toast: false,
      popupType: "Warning",
      popupMessage: "Are you sure you want to delete ?",
      showPopup: false,
      selectedItem: "",
      departmentColumnNames: [
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Description",
          key: "description"
        }
      ],
      blankInstance: {
        name: "",
        code: "",
        desp: ""
      },
      instance: null,
      newblankInstance: {
        name: "",
        code: "",
        desp: ""
      },
      new_instance: null,
      departmentsValue: false,
      role: ""
    };
  },
  mounted() {
    this.getOrgLeIdList();
  },
  activated() {
    this.getOrgLeIdList();
  },
  methods: {
    ...mapActions("onboard/departments/", {
      act_create: "create",
      act_update: "update",
      act_delete: "delete",
      act_changeEditMode: "changeEditMode"
    }),

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    goToIntro() {
      this.$emit("displayIntro");
    },

    clicknew(payload) {
      this.$emit("clicknew", payload);
    },
    previous() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/statutory`
      });
    },
    continuee() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/costcenters`
      });
    },
    disable() {
      this.$emit("displayIntro");
    },
    cancelForm() {
      this.showForm = false;
    },
    initCreateForm() {
      this.instance = this.$_.cloneDeep(this.blankInstance);
      this.isFormActive = true;
      this.showButton = false;
    },

    submitForm(payload) {
      this.create(payload);
    },
    submitNewForm(payload) {
      if (this.mode == "edit") {
        this.updateItem(payload);
      } else if (this.mode == "add") {
        this.create(payload);
      }
      this.showForm = false;
    },
    resetAndCloseForm() {
      this.showButton = false;
      this.showForm = false;
    },
    async create(instance) {
      //console.log(this.orgId);
      try {
        this.$root._data.isSaving = true;
        await this.act_create(
          {
            org_id: this.orgId,
            legalEntity: this.le_id,
            ...instance
          },
          this.le_id
        );
        //console.log("added data", instance);
        setTimeout(() => {
          this.resetAndCloseForm();
          this.$root._data.isSaving = false;
        }, 500);
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err.message;
      }
    },
    async updateItem(item) {
      try {
        this.$root._data.isSaving = true;
        await this.act_update([item, this.le_id]);
        // //console.log('cost centres updating', res)
        setTimeout(() => {
          this.$root._data.isSaving = false;
        }, 500);
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err.message;
      }
    },

    /* function to hide the pop-up */
    cancelEvent() {
      this.showPopup = false;
    },

    /* function to open the delete confirmation pop-up */
    deleteItem(record) {
      try {
        this.showPopup = true;
        this.selectedItem = record;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server to delete department */
    async deleteEvent() {
      try {
        let res = await this.act_delete([this.selectedItem, this.le_id]);
        if (res.data.status) {
          this.showPopup = false;
          this.selectedItem = null;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err.message;
      }
    },

    async createForm() {
      try {
        await this.act_changeEditMode({ editMode: false, record: {} });
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/${
            this.$route.params.step_name
          }/add`
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err.message;
      }
    },
    async initEditStart(record) {
      try {
        await this.act_changeEditMode({ editMode: true, record: record });
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/${
            this.$route.params.step_name
          }/modifydepartment`
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err.message;
      }
    },
    goToSalaryGradesIntro() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/grades`
      });
    },
    navHandler(navType) {
      this.$validator.reset();
      if (navType == "back") {
        this.$router.push({
          path: `/onboarding/entity/${
            this.$route.params.entity_index
          }/locations`
        });
      }
      if (navType == "next") {
        this.$validator.reset();
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/grades`
        });
      }
    },

    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.le_id;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.departmentsValue = data.data.user.permissions.departments ? true : false;
      //console.log("PL-3406",data);
    }
  }
};
</script>

<style lang="scss" scoped>
.sep {
  background-color: #34c0be;
  height: 2px;
  margin-top: 8px;
  border-color: #34c0be;
  border-style: solid;
  /* margin-bottom: 15px; */
}
.export-button {
  width: 70px;
  height: 25px;
  border-radius: 4px;
  font-family: Montserrat;
  font-size: 12px;
  text-align: center;
  border: 1px solid #5d409f;
  color: #5d409f;
}
.download-btn {
  margin: 15px 0px;
}
.enable-button {
  width: 13%;
  height: 35px;
  border-radius: 4px;
  font-family: Montserrat;
  font-size: 12px;
  text-align: center;
  border: 2px solid #5d409f;
  color: #5d409f;
  margin-left: 42%;
}
.tablesep {
  background-color: #34c0be;
  height: 2px;
  margin-top: 8px;
  border-color: #34c0be;
  border-style: solid;
  margin-bottom: 15px;
}

.buttondis {
  margin-left: auto;
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
  span {
    color: #858585;
    font-size: 18px;
  }
}

.disablebtn {
  align-items: center;
  display: flex;
  width: 100%;
  margin-bottom: 10px;
}
.top-heading {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 54px;
  background-color: #f5f6fa;

  .spacing {
    margin-left: 10px;
    grid-column-gap: 110%;
  }
}

.top-heading p {
  font-weight: bold;
  margin-top: 16px;
}

.placeAtEnd {
  margin-top: 130px;
}
.showIntro {
  cursor: pointer;
}
p {
  margin-top: 16px;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
